export default __webpack_public_path__ + "static/Inter-roman.var-ba4caefcdf5b36b438db92786991c845.woff2";